import React from 'react';

const CommonPopup = ({ show, onClose, type, url }) => {
  if (!show) return null; // show가 false면 아무것도 렌더링하지 않음

  const handleClick = (e) => {
    // 이미지가 아닌 다른 영역 클릭 시 닫기
    if (type === 'image') {
        onClose();
    }
  };

  return (
    <div id="common-popup" style={styles.overlay} onClick={handleClick}>
        {type !== 'image' && (
        <button style={styles.closeBtn} onClick={onClose}>×</button>
      )}
      <div style={styles.popup}>
        {type === 'youtube' && (
          <div style={styles.innerBox}>
            {/* <iframe src={url} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */}
            <iframe width="560" height="315" src={url} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'contain', // 이미지 비율 유지하며 꽉 채우기
  }}></iframe>
          </div>
        )}
        {type === 'image' && (
          <img
          src={url}
          alt="Popup Image"
          style={{
            maxWidth: '90vw', // 화면 폭 90%까지
            maxHeight: '90vh', // 화면 높이 90%까지
            width: 'auto',
            height: 'auto',
            display: 'block',
            margin: '0 auto',
            objectFit: 'contain',
          }}
        />
        )}
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top:0,
    left:0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    zIndex: 1000,
  },
  popup: {
    borderRadius: '8px',
    minWidth: '300px',
    position: 'relative',
    display: 'inline-block',
    verticalAlign: 'middle',
    maxWidth: '1140px',
    maxHeight: '100%',
    width: '100%',
    padding: '0 5px',
  },
  innerBox:{
    width: '100%',
    height: '0',
    paddingBottom: '56.25%',
    overflow: 'hidden',
    position: 'relative',
  },
  imageInnerBox:{
    width: '100%',
    height: 'auto',
    position: 'relative',
  },
  closeBtn: {
    position:'absolute',
    top: 30,
    right: 30,
    border: 'none',
    background: 'transparent',
    fontSize: 48,
    cursor: 'pointer',
  }
};

export default CommonPopup;